var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMainmenuCrashtrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3186 20.8099C10.3186 21.4287 10.5644 22.0222 11.002 22.4598C11.4396 22.8974 12.0331 23.1432 12.6519 23.1432C13.2708 23.1432 13.8643 22.8974 14.3019 22.4598C14.7394 22.0222 14.9853 21.4287 14.9853 20.8099C14.9853 20.1911 14.7394 19.5976 14.3019 19.16C13.8643 18.7224 13.2708 18.4766 12.6519 18.4766C12.0331 18.4766 11.4396 18.7224 11.002 19.16C10.5644 19.5976 10.3186 20.1911 10.3186 20.8099Z",
    stroke: "#304674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8187 13.8099L9.15202 7.97656H4.48535M13.8187 13.8099H14.9854C15.6042 13.8099 16.1977 14.0557 16.6353 14.4933C17.0729 14.9309 17.3187 15.5244 17.3187 16.1432V20.8099H14.9854M13.8187 13.8099H4.48535M10.3187 20.8099H4.48535M6.81868 13.8099V7.97656M17.3187 10.3099V7.97656M23.152 14.9766H25.4854M21.402 19.0599L23.152 20.8099M21.402 10.8932L23.152 9.14323",
    stroke: "#304674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainmenuCrashtrack);
export default __webpack_public_path__ + "static/media/icon-mainmenu-crashtrack.a62d7267d00fc16a270f6a54577c90a6.svg";
export { ForwardRef as ReactComponent };